import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["provider", "stripeFields", "genericFields", "slackHelp"]

  connect() {
    this.updateVisibility()
  }

  providerChanged() {
    this.updateVisibility()
  }

  updateVisibility() {
    const provider = this.hasProviderTarget ? this.providerTarget.value : ""
    this.toggleSection(this.hasStripeFieldsTarget ? this.stripeFieldsTarget : null, provider === "stripe")
    this.toggleSection(this.hasGenericFieldsTarget ? this.genericFieldsTarget : null, provider === "generic_hmac")
    if (this.hasSlackHelpTarget) {
      this.slackHelpTarget.classList.toggle("hidden", provider !== "slack")
    }
  }

  toggleSection(section, visible) {
    if (!section) return

    section.classList.toggle("hidden", !visible)

    section.querySelectorAll("input, select, textarea").forEach((field) => {
      field.disabled = !visible
    })
  }
}
